import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { GroundFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import { GetServerSideProps } from 'next';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import GroundHeader from '@amf/shared/components/ground/GroundHeader';
import GroundInfo from '@amf/shared/components/ground/GroundInfo';
import { useTranslate } from '@tolgee/react';
import GroundPhotos from '@amf/shared/components/ground/GroundPhotos';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

interface Props extends NavigationProps {
  ground: GroundFragment;
}

export default function GroundDetailPage({ navigation, partners, ground }: Props) {
  const { t } = useTranslate();
  return (
    <div className='GroundDetailPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={ground.name} />
        <GroundHeader ground={ground} prefixes={{ ground: AppLinks.ground }} />
        <Container>
          <h2>{t('ground.info.title')}</h2>
          <GroundInfo ground={ground} />
          {ground.photos.length > 0 && <GroundPhotos ground={ground} />}
        </Container>
      </Layout>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props, { id: string }> = async ({
  params,
  locale,
  res,
}) => {
  const { id } = params;
  const { ground } = await sdk.GroundDetail({ union: process.env.NEXT_PUBLIC_UNION, id });
  if (!ground) return { notFound: true };
  res.setHeader('Cache-Control', 'max-age=0, s-maxage=3600');

  return {
    props: {
      ground,
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
  };
};
